import { render, staticRenderFns } from "./InfoForInvalid.vue?vue&type=template&id=6e91321c&scoped=true&"
import script from "./InfoForInvalid.vue?vue&type=script&lang=js&"
export * from "./InfoForInvalid.vue?vue&type=script&lang=js&"
import style0 from "./InfoForInvalid.vue?vue&type=style&index=0&id=6e91321c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e91321c",
  null
  
)

export default component.exports